/**







 * WELDING TABLE CONFIGURATOR — ENGINE







 * ----------------------------------------------------------------







 * Vanilla JS, no dependencies.







 *







 * Pricing:







 * Product + Size = individual base table price from variantPrices.







 * Optional extras are added afterwards.







 * Ready Made labour varies automatically by selected table size.







 *







 * Legs / counted castors:







 * < 2500mm longest dimension  = 4







 * >= 2500mm longest dimension = 6







 *







 * SKU:







 * [PRODUCT]-[LENGTH]-[WIDTH]-[HOLE SYSTEM]-[BUILD][LEG OPTION]







 * Example: PR6-2000-1250-16D-RMLC







 * ----------------------------------------------------------------







 */







(function () {







  "use strict";







  // Shopify variant IDs are mapped manually in the DATA file by







  // product ID + selected table size. This lets Shopify use the







  // correct variant weight when calculating delivery at checkout.







  // §100 (6 Oct 2026): assembly plates sent FREE with a Self Weld Kit, one per internal rib crossing (ribs every 250mm).
  // Same counts for MidiPRO and PRO 6/8/10. Source: /workspace/mac/fixings/fixings-per-table.csv
  // 2900 x 1450 = 36 (confirmed by Jack 6 Oct). 1800 x 900 = 18 is an estimate awaiting confirmation. Hobby has no count yet -> "Included free".
  const MAC_PLATES_PER_SIZE = {
    "1000 x 1000mm": 9, "1250 x 750mm": 8, "1250 x 1000mm": 12, "1250 x 1250mm": 16,
    "1500 x 750mm": 10, "1500 x 1000mm": 15, "1500 x 1250mm": 20, "1500 x 1500mm": 25,
    "1750 x 750mm": 12, "1750 x 1000mm": 18, "1750 x 1250mm": 24, "1750 x 1500mm": 30,
    "1800 x 900mm": 18, "2000 x 1000mm": 21, "2000 x 1250mm": 28, "2500 x 1000mm": 27,
    "2500 x 1250mm": 36, "2900 x 1450mm": 36, "2900 x 1400mm": 36
  };
  const MAC_PLATES_PRODUCTS = /^(midipro|pro6|pro8|pro10|hobby)_/;
  // Hobby (Oct 2026): ready for plates and M12 x 175 studs like MidiPRO, but switched OFF until real plate counts exist.
  // No Hobby count is in the configurator data or fixings-per-table.csv, so this map is empty on purpose (do not guess).
  // Fill it, e.g. { "1200 x 600mm": N, "1200 x 800mm": N }, or set data.assemblyPlatesPerSizeHobby, to switch it on.
  const MAC_PLATES_HOBBY = {};
  // §101 (6 Oct 2026): optional "Self Weld Assembly Stud Kit" tick box (product 15934509613439, handle self-weld-assembly-stud-kit, UNLISTED).
  // 1 set (2 x M12 studs, 4 x M12 Form G washers, 4 x M12 nuts) per assembly plate, so quantity = getPlateCount().
  // M12 x 175 for MidiPRO, M12 x 275 for PRO 6 / 8 / 10. Prices are inc VAT (the store's prices include VAT) and are
  // refreshed from /products/<handle>.js on load; if that fails (e.g. product archived) the tick box stays hidden.
  // No plate count (Hobby) -> no tick box.
  const MAC_STUDKIT = {
    handle: "self-weld-assembly-stud-kit",
    m175: { id: 58627866919295, price: 5.10, unit: 2.55, studs: "M12 x 175", available: true },
    m275: { id: 58627866952063, price: 6.00, unit: 3.00, studs: "M12 x 275", available: true }
  };
  // Single studs (approved Oct 2026): 2 studs (with 4 washers and 4 nuts) per assembly plate, so quantity = 2 x plates at the
  // per-stud price (unit). This only switches on when the live variant price equals the per-stud price, so the basket can
  // never charge a per-set price for each stud. Until the stud kit product is repriced, the old per-set wording stays.
  const MAC_STUDKIT_CSS = `
    .wc .wc-studkit{margin:14px 0 0}
    .wc .wc-studkit[hidden]{display:none}
    .wc .wc-studkit__opt{position:relative;display:flex;align-items:flex-start;gap:12px;margin:0;padding:14px 16px;cursor:pointer;background:#fff;border:1px solid #c4c1ba;border-radius:0;color:#15171a;transition:border-color .15s,background-color .15s,box-shadow .15s}
    .wc .wc-studkit__opt:hover{border-color:#15171a}
    .wc .wc-studkit__opt:has(.wc-studkit__input:checked){border-color:#e21b23;background:#fdf1f1;box-shadow:0 0 0 1px #e21b23,0 14px 34px -20px rgba(226,27,35,.55)}
    .wc .wc-studkit__input{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}
    .wc .wc-studkit__box{flex:none;display:flex;align-items:center;justify-content:center;width:22px;height:22px;margin-top:1px;background:#fff;border:1px solid #8d8a84;border-radius:0;color:transparent}
    .wc .wc-studkit__box svg{width:14px;height:14px}
    .wc .wc-studkit__input:checked + .wc-studkit__box{background:#e21b23;border-color:#e21b23;color:#fff}
    .wc .wc-studkit__input:focus-visible + .wc-studkit__box{outline:2px solid #e21b23;outline-offset:2px}
    .wc .wc-studkit__text{display:flex;flex-direction:column;gap:4px;min-width:0}
    .wc .wc-studkit__title{font-family:var(--fb,inherit);font-size:16px;line-height:1.35;font-weight:700;color:#15171a;overflow-wrap:anywhere}
    .wc .wc-studkit__sub{font:500 12px/1.4 var(--mono,ui-monospace,SFMono-Regular,Menlo,Consolas,monospace);color:#6b7078;overflow-wrap:anywhere}
    .wc .wc-studkit__opt:has(.wc-studkit__input:checked) .wc-studkit__sub{color:#c4121a}
  `;

  class WeldingConfigurator {







    constructor(root, data) {







      this.root = root;







      this.data = data;







      this.state = {







        holeSystem: null,







        thickness: null,







        productId: null,







        size: null,







        legs: null,







        feet: null,







        build: null,







        legColor: null,







        studKit: false, // §101
        comments: ""







      };







      this.els = {







        downloadPdf: root.querySelector('[data-action="download-pdf"]'),







        step1: root.querySelector('[data-step="1"] .wc-options'),







        step2: root.querySelector('[data-step="2"] .wc-options'),







        step3: root.querySelector('[data-step="3"]'),







        step3Products: root.querySelector('[data-step="3"] .wc-products'),







        step3Sizes: root.querySelector('[data-step="3"] .wc-sizes'),







        step3SizeWrap: root.querySelector('[data-step="3"] .wc-size-wrap'),







        step4: root.querySelector('[data-step="4"]'),







        step4Legs: root.querySelector('[data-step="4"] .wc-legs'),







        step4Feet: root.querySelector('[data-step="4"] .wc-feet'),







        step4FeetWrap: root.querySelector('[data-step="4"] .wc-feet-wrap'),







        step5: root.querySelector('[data-step="5"]'),







        step5Options: root.querySelector('[data-step="5"] .wc-options'),







        step6: root.querySelector('[data-step="6"]'),







        step6Options: root.querySelector('[data-step="6"] .wc-options'),







        comments: root.querySelector('[data-role="comments"]'),







        commentsCount: root.querySelector('[data-role="comments-count"]'),







        previewImage:







          root.querySelector('[data-role="preview-image"]') ||







          root.querySelector('.wc__sidebar img'),







        summary: root.querySelector('[data-role="summary"]'),







        price: root.querySelector('[data-role="price"]'),







        addToQuote: root.querySelector('[data-action="add-to-quote"]'),







        requestQuote: root.querySelector('[data-action="request-quote"]'),







        reset: root.querySelector('[data-action="reset"]')







      };







      this.init();







    }







    init() {







      this.renderHoleSystems();







      this.bindStaticEvents();
      this.initStudKit(); // §101
      this.applyPreset();
      this.applyDefaults();







      this.refresh();







    }







    applyDefaults() {







      if (!this.state.holeSystem) {







        const first = this.data.holeSystems.find(h => h.enabled);







        if (first) this.state.holeSystem = first.id;







      }







      if (this.state.thickness == null) {







        const opts = this.availableThicknesses();







        if (opts.length) this.state.thickness = opts[0];







      }







      if (!this.state.productId) {







        const opts = this.availableProducts();







        if (opts.length) this.state.productId = opts[0].id;







      }







      const product = this.product;







      if (!product) return;







      if (!this.state.size && product.workingAreas && product.workingAreas.length) {







        this.state.size = product.workingAreas[0];







      }







      if (product.legs && !this.state.legs) {







        this.state.legs = product.legs[0];







      }







      if (product.feet && this.hasLegsSelected() && !this.state.feet) {







        this.state.feet = product.feet[0];







      }







      if (product.build && !this.state.build) {







        this.state.build = product.build[0];







      }







      if (







        product.legColors &&







        this.state.build === "Ready Made by Mac" &&







        !this.state.legColor







      ) {







        this.state.legColor = product.legColors[0];







      }







    }







    get product() {







      return this.data.products.find(p => p.id === this.state.productId) || null;







    }







    availableThicknesses() {







      if (!this.state.holeSystem) return [];







      const set = new Set(







        this.data.products







          .filter(p => p.holeSystem === this.state.holeSystem)







          .map(p => p.thickness)







      );







      return Array.from(set).sort((a, b) => a - b);







    }







    availableProducts() {







      if (!this.state.holeSystem || this.state.thickness == null) return [];







      return this.data.products.filter(







        p =>







          p.holeSystem === this.state.holeSystem &&







          p.thickness === this.state.thickness







      );







    }







    fmtPrice(n) {







      return this.data.currency + Number(n || 0).toLocaleString(undefined, {







        minimumFractionDigits: 2,







        maximumFractionDigits: 2







      });







    }







    getVariantPrice(product, size) {







      if (!product || !size) return null;







      const variantPrices = this.data.variantPrices || {};







      const productPrices = variantPrices[product.id];







      if (!productPrices) return null;







      if (Object.prototype.hasOwnProperty.call(productPrices, size)) {







        return Number(productPrices[size]);







      }







      return null;







    }







    getProductFromPrice(product) {
      // MAC fix 26 Oct 2026: "From" = cheapest size at its default build. When Self Weld is not offered
      // (e.g. ULTRA 15, Ready Made only) the compulsory Ready Made labour is included, so it matches the size price shown.
      const variantPrices = this.data.variantPrices || {};
      const productPrices = variantPrices[product.id];
      if (!productPrices) return Number(product.basePrice || 0);
      const labourIncluded = !!(product.build && product.build[0] === "Ready Made by Mac");
      const prices = Object.keys(productPrices)
        .map(size => Number(productPrices[size]) + (labourIncluded ? this.getReadyMadePrice(product, size) : 0))
        .filter(Number.isFinite);
      if (!prices.length) return Number(product.basePrice || 0);
      return Math.min(...prices);
    }







    // =========================================================







    // LEG / CASTOR QUANTITY







    // =========================================================







    getLegCount(size) {







      if (!size) return 4;







      const dimensions = String(size).match(/\d+/g);







      if (!dimensions) return 4;







      const longestDimension = Math.max(...dimensions.map(Number));







      // Below 2500mm = 4 legs / castors







      // 2500mm and above = 6 legs / castors







      return longestDimension >= 2500 ? 6 : 4;







    }







    hasLegsSelected() {







      return !!(







        this.state.legs &&







        this.state.legs !== "No Legs"







      );







    }







    getLegTotalPrice() {







      if (!this.hasLegsSelected()) return 0;







      const mods = this.data.priceModifiers || {};







      const pricePerLeg = Number(







        (mods.legs && mods.legs[this.state.legs]) || 0







      );







      return pricePerLeg * this.getLegCount(this.state.size);







    }







    getFeetTotalPrice() {







      if (!this.hasLegsSelected() || !this.state.feet) return 0;







      const mods = this.data.priceModifiers || {};







      const unitPrice = Number(







        (mods.feet && mods.feet[this.state.feet]) || 0







      );







      // Castors are priced per individual castor and follow the table leg count:







      // below 2500mm = 4







      // 2500mm and above = 6







      if (







        this.state.feet === "FM Castors" ||







        this.state.feet === "Standard Castors"







      ) {







        return unitPrice * this.getLegCount(this.state.size);







      }







      // Other leg-end options keep their existing flat/set price.







      return unitPrice;







    }







    // ---------- READY MADE LABOUR ----------







    getReadyMadePrice(product, size) {







      if (!product || !size) return 0;







      const readyMade = this.data.readyMadePrices || {};







      const byProduct = readyMade.byProduct || {};







      const productPrices = byProduct[product.id] || {};







      // Product-specific price takes priority if one has been set.







      if (Object.prototype.hasOwnProperty.call(productPrices, size)) {







        return Number(productPrices[size] || 0);







      }







      // Otherwise use the standard labour price for that table size.







      const defaultBySize = readyMade.defaultBySize || {};







      if (Object.prototype.hasOwnProperty.call(defaultBySize, size)) {







        return Number(defaultBySize[size] || 0);







      }







      // Fallback to the old flat build modifier if a size is ever missing.







      const mods = this.data.priceModifiers || {};







      return Number(







        (mods.build && mods.build["Ready Made by Mac"]) || 0







      );







    }







    getBuildPrice(product) {







      if (!product || !product.build || !this.state.build) return 0;







      if (this.state.build === "Self Weld Kit") {







        return 0;







      }







      if (this.state.build === "Ready Made by Mac") {







        return this.getReadyMadePrice(product, this.state.size);







      }







      const mods = this.data.priceModifiers || {};







      return Number(







        (mods.build && mods.build[this.state.build]) || 0







      );







    }







    // ---------- SKU ----------







    getSizeSkuCode(size) {







      if (!size) return null;







      const match = String(size).match(/(\d+)\s*x\s*(\d+)/i);







      if (!match) return null;







      return `${match[1]}-${match[2]}`;







    }







    getBuildSkuCode(product) {







      // Products with no build choice are treated as ready made.







      if (!product || !product.build) return "RM";







      if (this.state.build === "Ready Made by Mac") {







        return "RM";







      }







      if (this.state.build === "Self Weld Kit") {







        return "SW";







      }







      return null;







    }







    getLegSkuCode(product) {







      // Products with no leg choice are top only.







      if (!product || !product.legs) {







        return "NL";







      }







      if (this.state.legs === "No Legs") {







        return "NL";







      }







      // Standard Legs







      if (this.state.legs === "Standard Legs") {







        // Both FM Castors and Standard Castors use the LC SKU suffix.







        if (







          this.state.feet === "FM Castors" ||







          this.state.feet === "Standard Castors"







        ) {







          return "LC";







        }







        if (this.state.feet === "Adjustable Feet") {







          return "LF";







        }







      }







      // Height Adjustable Legs keep their own SKU codes.







      if (this.state.legs === "Height Adjustable Legs") {







        if (this.state.feet === "FM Castors") {







          return "HAC";







        }







        if (this.state.feet === "Adjustable Feet") {







          return "HAF";







        }







      }







      return null;







    }







    // §100: number of free assembly plates for the selected (or given) size; null when not known (e.g. Hobby)
    getPlateCount(size) {
      const product = this.product;
      if (!product || !MAC_PLATES_PRODUCTS.test(String(product.id || ""))) return null;
      const map = /^hobby_/.test(String(product.id || ""))
        ? ((this.data && this.data.assemblyPlatesPerSizeHobby) || MAC_PLATES_HOBBY)
        : ((this.data && this.data.assemblyPlatesPerSize) || MAC_PLATES_PER_SIZE);
      const n = Number(map[size || this.state.size]);
      return n > 0 ? n : null;
    }

    platesLabel() {
      const n = this.getPlateCount();
      return n ? `${n} included free` : "Included free";
    }

    // §101: assembly stud kit offer for the current build, or null (not self weld, no plate count e.g. Hobby, or kit unavailable)
    getStudKitOffer() {
      if (this.studKitUnavailable || this.state.build !== "Self Weld Kit") return null;
      const product = this.product;
      if (!product) return null;
      const qty = this.getPlateCount();
      if (!qty) return null;
      const pid = String(product.id || "");
      const variant = /^(midipro|hobby)_/.test(pid) ? MAC_STUDKIT.m175 : (/^pro(6|8|10)_/.test(pid) && !/28d/i.test(pid)) ? MAC_STUDKIT.m275  /* 28D excluded until a 28D stud spec exists */ : null;
      if (!variant || variant.available === false || !(variant.price > 0)) return null;
      const single = variant.unit > 0 && Math.abs(variant.price - variant.unit) < 0.005;
      const n = single ? qty * 2 : qty;
      return { variant: variant, qty: n, plates: qty, single: single, total: Math.round(n * variant.price * 100) / 100 };
    }
    // the offer only when ticked (used for the summary, total and cart)
    getStudKitSelected() {
      return this.state.studKit ? this.getStudKitOffer() : null;
    }
    studKitVatRate() {
      return Number.isFinite(Number(this.data.vatRate)) ? Number(this.data.vatRate) : 0.20;
    }
    studKitExVat() {
      const kit = this.getStudKitSelected();
      return kit ? kit.total / (1 + this.studKitVatRate()) : 0;
    }
    initStudKit() {
      const host = this.els.step5Options;
      if (!host || this.els.studKit) return;
      if (!document.getElementById("wc-studkit-css")) {
        const style = document.createElement("style");
        style.id = "wc-studkit-css";
        style.textContent = MAC_STUDKIT_CSS;
        document.head.appendChild(style);
      }
      const wrap = document.createElement("div");
      wrap.className = "wc-studkit";
      wrap.hidden = true;
      wrap.innerHTML = `
        <label class="wc-studkit__opt">
          <input type="checkbox" class="wc-studkit__input" data-role="studkit">
          <span class="wc-studkit__box" aria-hidden="true"><svg viewBox="0 0 16 16" focusable="false"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square"/></svg></span>
          <span class="wc-studkit__text">
            <span class="wc-studkit__title" data-role="studkit-title"></span>
            <span class="wc-studkit__sub" data-role="studkit-sub"></span>
          </span>
        </label>`;
      host.insertAdjacentElement("afterend", wrap);
      this.els.studKit = wrap;
      this.els.studKitInput = wrap.querySelector('[data-role="studkit"]');
      this.els.studKitInput.addEventListener("change", (e) => {
        this.state.studKit = !!e.target.checked;
        this.renderStudKit();
        this.renderSummary();
      });
      // live prices / availability from the storefront; hide the option if the product can't be loaded
      fetch(`/products/${MAC_STUDKIT.handle}.js`, { headers: { "Accept": "application/json" } })
        .then(res => res.ok ? res.json() : Promise.reject(new Error("HTTP " + res.status)))
        .then(p => {
          [MAC_STUDKIT.m175, MAC_STUDKIT.m275].forEach(v => {
            const live = (p.variants || []).find(x => Number(x.id) === v.id);
            if (!live) { v.available = false; return; }
            v.price = Number(live.price) / 100;
            v.available = !!live.available;
          });
        })
        .catch(err => {
          this.studKitUnavailable = true;
          this.state.studKit = false;
          console.warn("Welding configurator: stud kit not available", err);
        })
        .finally(() => {
          this.renderStudKit();
          this.renderSummary();
        });
    }
    renderStudKit() {
      const wrap = this.els.studKit;
      if (!wrap) return;
      const offer = this.getStudKitOffer();
      wrap.hidden = !offer;
      if (!offer) return;
      this.els.studKitInput.checked = !!this.state.studKit;
      const exVat = offer.total / (1 + this.studKitVatRate());
      wrap.querySelector('[data-role="studkit-title"]').textContent = offer.single
        ? `Add ${offer.qty} studs (${offer.variant.studs}) + nuts & washers, ${this.fmtPrice(offer.total)}`
        : `Add assembly stud kit: ${offer.qty} sets (1 per plate), ${this.fmtPrice(offer.total)}`;
      wrap.querySelector('[data-role="studkit-sub"]').textContent = offer.single
        ? `2 studs, 4 washers and 4 nuts per assembly plate. ${this.fmtPrice(offer.variant.price)} per stud, ${this.fmtPrice(exVat)} ex VAT in total.`
        : `${offer.variant.studs} studs. Each set: 2 studs, 4 Form G washers, 4 nuts. ${this.fmtPrice(offer.variant.price)} per set, ${this.fmtPrice(exVat)} ex VAT in total.`;
    }
    generateSku() {







      const product = this.product;







      if (







        !product ||







        !this.state.size ||







        !this.state.holeSystem







      ) {







        return null;







      }







      const prefixMap = this.data.skuPrefixes || {};







      const prefix = prefixMap[product.id];







      const sizeCode = this.getSizeSkuCode(this.state.size);







      const buildCode = this.getBuildSkuCode(product);







      const legCode = this.getLegSkuCode(product);







      if (







        !prefix ||







        !sizeCode ||







        !buildCode ||







        !legCode







      ) {







        return null;







      }







      return `${prefix}-${sizeCode}-${this.state.holeSystem}-${buildCode}${legCode}`;







    }







    // ---------- SHOPIFY VARIANT MAPPING ----------







    getShopifyVariantId(product, size) {







      if (!product || !size) return null;







      const allVariantIds = this.data.shopifyVariantIds || {};







      const productVariantIds = allVariantIds[product.id] || {};







      const rawId = productVariantIds[size];







      const variantId = Number(rawId);







      return Number.isFinite(variantId) && variantId > 0







        ? variantId







        : null;







    }







    iconUrl(filename) {







      if (!filename) return "";







      if (







        window.WC_ICON_URLS &&







        window.WC_ICON_URLS[filename]







      ) {







        return window.WC_ICON_URLS[filename];







      }







      return "" + filename;







    }







    iconImg(filename, alt, cls) {







      if (!filename) return "";







      return `







        <img







          src="${this.iconUrl(filename)}"







          alt="${alt || ""}"







          class="${cls || "wc-icon"}"







          loading="lazy"







        >







      `;







    }







    // ---------- CONFIGURATION PREVIEW IMAGE ----------







    getPreviewImageFilename(product) {







      if (!product) return "";







      const previews = product.previewImages || {};







      let filename =







        previews.default ||







        product.previewImage ||







        product.image ||







        "";







      if (







        this.state.legs &&







        previews.legs &&







        previews.legs[this.state.legs]







      ) {







        filename = previews.legs[this.state.legs];







      }







      if (







        this.state.feet &&







        previews.feet &&







        previews.feet[this.state.feet]







      ) {







        filename = previews.feet[this.state.feet];







      }







      if (







        this.state.build &&







        previews.build &&







        previews.build[this.state.build]







      ) {







        filename = previews.build[this.state.build];







      }







      if (







        this.state.legColor &&







        previews.legColors &&







        previews.legColors[this.state.legColor]







      ) {







        filename = previews.legColors[this.state.legColor];







      }







      const combinationKey = [







        this.state.legs || "",







        this.state.feet || "",







        this.state.build || "",







        this.state.legColor || ""







      ].join("|");







      if (







        previews.combinations &&







        previews.combinations[combinationKey]







      ) {







        filename = previews.combinations[combinationKey];







      }







      return filename;







    }







    renderPreview() {







      const imageEl = this.els.previewImage;







      if (!imageEl) return;







      const product = this.product;







      const filename = this.getPreviewImageFilename(product);







      if (!product || !filename) {







        imageEl.hidden = true;







        imageEl.removeAttribute("src");







        imageEl.alt = "";







        return;







      }







      const url = this.iconUrl(filename);







      if (imageEl.getAttribute("src") !== url) {







        imageEl.setAttribute("src", url);







      }







      imageEl.alt = `${product.name} welding table`;







      imageEl.hidden = false;







    }







    renderHoleSystems() {







      const mods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.holeSystem







        ) || null;







      this.els.step1.innerHTML = this.data.holeSystems.map(hs => `







        <button







          type="button"







          class="wc-card wc-card--icon${hs.id === this.state.holeSystem ? " is-selected" : ""}${hs.enabled ? "" : " wc-card--disabled"}"







          data-action="hole-system"







          data-value="${hs.id}"







          ${hs.enabled ? "" : "disabled"}







        >







          ${this.iconImg(hs.icon, hs.label)}







          <span class="wc-card__label">${hs.label}</span>







          ${







            hs.enabled







              ? this.priceBadge(mods, hs.id)







              : '<span class="wc-card__badge">Coming soon</span>'







          }







        </button>







      `).join("");







    }







    renderThicknesses() {







      const options = this.availableThicknesses();







      const icons = this.data.thicknessIcons || {};







      const mods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.thickness







        ) || null;







      this.els.step2.innerHTML = options.map(t => `







        <button







          type="button"







          class="wc-card wc-card--icon${t === this.state.thickness ? " is-selected" : ""}"







          data-action="thickness"







          data-value="${t}"







        >







          ${this.iconImg(icons[t], t + "mm")}







          <span class="wc-card__label">${t}mm</span>







          ${this.priceBadge(mods, t)}







        </button>







      `).join("");







      this.toggleStep(2, options.length > 0);







    }







    renderProducts() {







      const products = this.availableProducts();







      this.els.step3Products.innerHTML = products.map(p => {







        const fromPrice = this.getProductFromPrice(p);







        return `







          <button







            type="button"







            class="wc-product${p.id === this.state.productId ? " is-selected" : ""}"







            data-action="product"







            data-value="${p.id}"







          >







            ${







              p.image







                ? `<img src="${this.iconUrl(p.image)}" alt="${p.name}" class="wc-product__img">`







                : '<span class="wc-product__img wc-product__img--placeholder"></span>'







            }







            <span class="wc-product__name">







              ${p.name}







            </span>







            ${







              fromPrice







                ? `<span class="wc-product__price">From ${this.fmtPrice(fromPrice)}</span>`







                : ""







            }







          </button>







        `;







      }).join("");







      this.toggleStep(3, products.length > 0);







      this.renderSizes();







    }







    renderSizes() {







      const product = this.product;







      if (!product) {







        this.els.step3SizeWrap.hidden = true;







        return;







      }







      const oldMods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.sizes







        ) || null;







      this.els.step3SizeWrap.hidden = false;







      this.els.step3Sizes.innerHTML = product.workingAreas.map(size => {







        const variantPrice = this.getVariantPrice(product, size);







        let priceText = "";







        if (variantPrice !== null) {







          priceText = this.fmtPrice(variantPrice);







        } else if (oldMods) {







          const modifier = Number(oldMods[size] || 0);







          if (modifier > 0) {







            priceText = "+" + this.fmtPrice(modifier);







          }







        }







        return `







          <button







            type="button"







            class="wc-chip${size === this.state.size ? " is-selected" : ""}"







            data-action="size"







            data-value="${size}"







          >







            ${size}







            ${







              priceText







                ? `<span class="wc-chip__price">${priceText}</span>`







                : ""







            }







          </button>







        `;







      }).join("");







    }







    renderLegs() {







      const product = this.product;







      const hasLegs = !!(product && product.legs);







      this.toggleStep(4, hasLegs);







      if (!hasLegs) return;







      const icons = this.data.legIcons || {};







      const mods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.legs







        ) || null;







      const legCount = this.getLegCount(this.state.size);







      this.els.step4Legs.innerHTML = product.legs.map(v => {







        let badge = "";







        if (v !== "No Legs") {







          const pricePerLeg = Number(







            (mods && mods[v]) || 0







          );







          const total =







            pricePerLeg * legCount;







          badge = `







            <span class="wc-card__price">







              +${this.fmtPrice(total)} • ${legCount} Legs







            </span>







          `;







        } else {







          badge = this.priceBadge(mods, v);







        }







        return `







          <button







            type="button"







            class="wc-card wc-card--icon${v === this.state.legs ? " is-selected" : ""}"







            data-action="legs"







            data-value="${v}"







          >







            ${this.iconImg(icons[v], v)}







            <span class="wc-card__label">







              ${v}







            </span>







            ${badge}







          </button>







        `;







      }).join("");







      this.renderFeet();







    }







    renderFeet() {







      const product = this.product;







      const showFeet = !!(







        product &&







        product.feet &&







        this.hasLegsSelected()







      );







      this.els.step4FeetWrap.hidden = !showFeet;







      if (!showFeet) return;







      const icons = this.data.feetIcons || {};







      const mods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.feet







        ) || null;







      const legCount = this.getLegCount(this.state.size);







      this.els.step4Feet.innerHTML = product.feet.map(v => {







        let badge = "";







        if (







          v === "FM Castors" ||







          v === "Standard Castors"







        ) {







          const pricePerCastor = Number(







            (mods && mods[v]) || 0







          );







          const total =







            pricePerCastor * legCount;







          badge = `







            <span class="wc-card__price">







              +${this.fmtPrice(total)} • ${legCount} Castors







            </span>







          `;







        } else {







          badge = this.priceBadge(mods, v);







        }







        return `







          <button







            type="button"







            class="wc-card wc-card--icon${v === this.state.feet ? " is-selected" : ""}"







            data-action="feet"







            data-value="${v}"







          >







            ${this.iconImg(icons[v], v)}







            <span class="wc-card__label">







              ${v}







            </span>







            ${badge}







          </button>







        `;







      }).join("");







    }







    renderBuild() {







      const product = this.product;







      const hasBuild = !!(product && product.build);







      this.toggleStep(5, hasBuild);







      if (!hasBuild) return;







      const icons = this.data.buildIcons || {};







      const mods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.build







        ) || null;







      this.els.step5Options.innerHTML = product.build.map(v => {







        let badge = "";







        if (v === "Ready Made by Mac") {







          const labourPrice = this.getReadyMadePrice(







            product,







            this.state.size







          );







          badge =







            labourPrice > 0







              ? `<span class="wc-card__price">+${this.fmtPrice(labourPrice)}</span>`







              : '<span class="wc-card__price">Included</span>';







        } else {







          badge = this.priceBadge(mods, v);







        }







        return `







          <button







            type="button"







            class="wc-card wc-card--icon${v === this.state.build ? " is-selected" : ""}"







            data-action="build"







            data-value="${v}"







          >







            ${this.iconImg(icons[v], v)}







            <span class="wc-card__label">







              ${v}







            </span>

            ${
              v === "Self Weld Kit"
                ? `<span style="
                    display:block;
                    margin-top:4px;
                    font-size:12px;
                    font-weight:800;
                    color:#e21b23;
                    text-transform:uppercase;
                  ">
                    ${this.getPlateCount() ? `${this.getPlateCount()} Assembly Plates Included Free` : "FREE Assembly Plates Included"}
                  </span>`
                : ""
            }

            <span style="
              display:block;
              margin-top:4px;
              font-size:12px;
              font-weight:800;
              color:#e21b23;
              text-transform:uppercase;
            ">
              FREE Clamp Hanger with All Weld Tables
            </span>

            ${badge}







          </button>







        `;







      }).join("");







      if (







        product.build.length === 1 &&







        !this.state.build







      ) {







        this.state.build = product.build[0];







      }







    }







    renderLegColors() {







      const product = this.product;







      const showColors = !!(







        product &&







        product.legColors &&







        this.state.build === "Ready Made by Mac"







      );







      this.toggleStep(6, showColors);







      if (!showColors) return;







      const icons = this.data.legColorIcons || {};







      const mods =







        (







          this.data.priceModifiers &&







          this.data.priceModifiers.legColors







        ) || null;







      this.els.step6Options.innerHTML = product.legColors.map(v => {







        const icon = icons[v];







        return `







          <button







            type="button"







            class="wc-swatch${icon ? " wc-swatch--icon" : ""}${v === this.state.legColor ? " is-selected" : ""}"







            data-action="leg-color"







            data-value="${v}"







            title="${v}"







          >







            ${







              icon







                ? this.iconImg(icon, v, "wc-swatch__icon")







                : `<span class="wc-swatch__dot" data-color="${v.toLowerCase().replace(/\s+/g, "-")}"></span>`







            }







            <span class="wc-swatch__label">







              ${v}







            </span>







            ${this.priceBadge(mods, v)}







          </button>







        `;







      }).join("");







    }







    toggleStep(n, show) {







      const el = this.root.querySelector(`[data-step="${n}"]`);







      if (el) {







        el.hidden = !show;







      }







    }







    // =========================================================







    // PRICE CALCULATION







    // =========================================================







    calcPrice() {







      const product = this.product;







      if (!product) return 0;







      const mods = this.data.priceModifiers || {};







      const variantPrice = this.getVariantPrice(







        product,







        this.state.size







      );







      let total;







      if (variantPrice !== null) {







        total = variantPrice;







      } else {







        total = Number(product.basePrice || 0);







        total += Number(







          (mods.holeSystem && mods.holeSystem[this.state.holeSystem]) || 0







        );







        total += Number(







          (mods.thickness && mods.thickness[this.state.thickness]) || 0







        );







        total += Number(







          (mods.sizes && mods.sizes[this.state.size]) || 0







        );







      }







      if (this.hasLegsSelected()) {







        total += this.getLegTotalPrice();







      }







      total += this.getFeetTotalPrice();







      total += this.getBuildPrice(product);







      total += Number(







        (mods.legColors && mods.legColors[this.state.legColor]) || 0







      );







      return total;







    }







    priceBadge(modGroup, key) {







      if (!modGroup || !(key in modGroup)) return "";







      const n = Number(modGroup[key] || 0);







      const text =







        n > 0







          ? `+${this.fmtPrice(n)}`







          : "Included";







      return `







        <span class="wc-card__price">







          ${text}







        </span>







      `;







    }







    // =========================================================







    // SUMMARY







    // =========================================================







    renderSummary() {







      const product = this.product;







      const rows = [];







      const hs = this.data.holeSystems.find(







        h => h.id === this.state.holeSystem







      );







      const sku = this.generateSku();







      if (hs) {







        rows.push([







          "Hole Size (System)",







          hs.label







        ]);







      }







      if (this.state.thickness != null) {







        rows.push([







          "Top Plate Thickness",







          this.state.thickness + "mm"







        ]);







      }







      if (product) {







        rows.push([







          "Table Type",







          product.name







        ]);







      }







      if (this.state.size) {







        rows.push([







          "Table Size",







          this.state.size







        ]);







      }







      if (this.state.legs) {







        let legText =







          this.state.legs;







        if (this.hasLegsSelected()) {







          legText =







            `${this.state.legs} (${this.getLegCount(this.state.size)} Legs)`;







        }







        rows.push([







          "Legs",







          legText







        ]);







      }







      if (this.state.feet) {







        let feetText =







          this.state.feet;







        if (







          this.state.feet === "FM Castors" ||







          this.state.feet === "Standard Castors"







        ) {







          feetText =







            `${this.state.feet} (${this.getLegCount(this.state.size)} Castors)`;







        }







        rows.push([







          "Leg End",







          feetText







        ]);







      }







      if (this.state.build) {







        rows.push([







          "Build Option",







          this.state.build







        ]);







      }

      // §100: free assembly plates for the chosen size
      if (this.state.build === "Self Weld Kit") {
        rows.push([
          "Assembly Plates",
          this.platesLabel()
        ]);
      }







      // §101: optional assembly stud kit
      const studKitRow = this.getStudKitSelected();
      if (studKitRow) {
        rows.push([
          "Assembly Stud Kit",
          studKitRow.single
            ? `${studKitRow.qty} studs (${studKitRow.variant.studs}) + nuts & washers, ${this.fmtPrice(studKitRow.total)}`
            : `${studKitRow.qty} sets (${studKitRow.variant.studs}), ${this.fmtPrice(studKitRow.total)}`
        ]);
      }
      if (this.state.legColor) {







        rows.push([







          "Leg Finish",







          this.state.legColor







        ]);







      }







      if (sku) {







        rows.push([







          "SKU",







          sku







        ]);







      }







      if (this.state.comments) {







        rows.push([







          "Comments",







          this.state.comments







        ]);







      }







      this.els.summary.innerHTML = rows.map(([label, val]) => `







        <div class="wc-summary__row">







          <span>${label}</span>







          <span>${this.escapeHtml(val)}</span>







        </div>







      `).join("") || `







        <p class="wc-summary__empty">







          Start configuring your table to see a summary here.







        </p>







      `;







      const priceExVat = this.calcPrice() + this.studKitExVat(); // §101: + stud kit if ticked (display only; the table line __price stays table-only)







      const vatRate =







        Number.isFinite(Number(this.data.vatRate))







          ? Number(this.data.vatRate)







          : 0.20;







      const priceIncVat =







        priceExVat * (1 + vatRate);







      if (this.els.price) {







        this.els.price.innerHTML = product







          ? `<span class="wc-price__ex" style="font-size:0.9em; font-weight:400;">${this.fmtPrice(priceExVat)} <small style="font-size:0.7em; font-weight:400;">ex VAT</small></span><br>` +







            `<span class="wc-price__inc">${this.fmtPrice(priceIncVat)} <small style="font-size:0.7em;">inc VAT</small></span>`







          : "—";







      }







      const ready = this.isConfigReady();







      const shopifyVariantId =







        this.getShopifyVariantId(







          product,







          this.state.size







        );







      if (this.els.addToQuote) {







        this.els.addToQuote.disabled =







          !ready ||







          !shopifyVariantId;







      }







      if (this.els.requestQuote) {







        this.els.requestQuote.disabled =







          !ready;







      }







      if (this.els.downloadPdf) {







        this.els.downloadPdf.disabled =







          !(product && product.drawingPdf);







      }







    }







    escapeHtml(str) {







      const div =







        document.createElement("div");







      div.textContent =







        String(str);







      return div.innerHTML;







    }







    refresh() {







      this.renderHoleSystems();







      this.renderThicknesses();







      this.renderProducts();







      this.renderLegs();







      this.renderBuild();







      this.renderLegColors();
      this.renderStudKit(); // §101







      this.renderPreview();







      this.renderSummary();







      this.updateStepper();







    }







    updateStepper() {







      const steps =







        [1, 2, 3, 4, 5, 6, 7];







      const doneUpTo =







        this.currentStepIndex();







      steps.forEach(n => {







        const dot =







          this.root.querySelector(







            `[data-stepper="${n}"]`







          );







        if (!dot) return;







        dot.classList.toggle(







          "is-done",







          n <= doneUpTo







        );







      });







    }







    currentStepIndex() {







      if (this.state.comments) return 7;







      if (this.state.legColor) return 6;







      if (this.state.build) return 5;







      if (this.state.feet || this.state.legs === "No Legs") return 4;







      if (this.state.size) return 3;







      if (this.state.thickness != null) return 2;







      if (this.state.holeSystem) return 1;







      return 0;







    }







    // =========================================================







    // EVENTS







    // =========================================================







    bindStaticEvents() {







      this.root.addEventListener("click", (e) => {







        const btn =







          e.target.closest("[data-action]");







        if (!btn || btn.disabled) return;







        const action =







          btn.dataset.action;







        const value =







          btn.dataset.value;







        switch (action) {







          case "hole-system":







            this.state.holeSystem = value;







            this.state.thickness = null;







            this.resetFrom("product");







            break;







          case "thickness":







            this.state.thickness = Number(value);







            this.resetFrom("product");







            break;







          case "download-pdf":







            this.downloadPdf();







            break;







          case "product":







            this.state.productId = value;







            this.resetFrom("size");







            break;







          case "size":







            this.state.size = value;







            break;







          case "legs":







            this.state.legs = value;







            this.state.feet = null;







            break;







          case "feet":







            this.state.feet = value;







            break;







          case "build":







            this.state.build = value;







            this.state.legColor = null;







            break;







          case "leg-color":







            this.state.legColor = value;







            break;







          case "reset":







            this.resetAll();







            break;







          case "add-to-quote":







            this.addToQuote();







            break;







          case "request-quote":







            this.requestQuote();







            break;







        }







        if (







          action !== "add-to-quote" &&







          action !== "request-quote" &&







          action !== "download-pdf"







        ) {







          this.applyDefaults();







        }







        this.refresh();







      });







      if (this.els.comments) {







        this.els.comments.addEventListener(







          "input",







          (e) => {







            this.state.comments =







              e.target.value.slice(







                0,







                500







              );







            if (this.els.commentsCount) {







              this.els.commentsCount.textContent =







                `${this.state.comments.length} / 500`;







            }







            this.renderSummary();







          }







        );







      }







    }







    resetFrom(field) {







      const order = [







        "productId",







        "size",







        "legs",







        "feet",







        "build",







        "legColor"







      ];







      const start =







        order.indexOf(







          field === "product"







            ? "productId"







            : field







        );







      if (start < 0) return;







      order







        .slice(start)







        .forEach(k => {







          this.state[k] = null;







        });







    }







    resetAll() {







      Object.keys(this.state).forEach(k => {







        this.state[k] =







          k === "comments"







            ? ""







            : null;







      });







      if (this.els.comments) {







        this.els.comments.value = "";







      }







      if (this.els.commentsCount) {







        this.els.commentsCount.textContent = "0 / 500";







      }







      this.applyDefaults();







    }







    // =========================================================







    // PAYLOAD







    // =========================================================







    buildPayload() {







      const product = this.product;







      const legCount =







        this.hasLegsSelected()







          ? this.getLegCount(this.state.size)







          : null;







      return {







        sku:







          this.generateSku(),







        product:







          product







            ? product.name







            : null,







        productId:







          product







            ? product.id







            : null,







        shopifyVariantId:







          this.getShopifyVariantId(







            product,







            this.state.size







          ),







        holeSystem:







          this.state.holeSystem,







        thickness:







          this.state.thickness,







        size:







          this.state.size,







        legs:







          this.state.legs,







        legCount:







          legCount,







        feet:







          this.state.feet,







        build:







          this.state.build,

        plates:
          this.state.build === "Self Weld Kit" ? this.getPlateCount() : null,







        readyMadeLabour:







          this.state.build === "Ready Made by Mac"







            ? this.getReadyMadePrice(







                product,







                this.state.size







              )







            : 0,







        legColor:







          this.state.legColor,







        comments:







          this.state.comments,







        estimatedPrice:







          this.calcPrice(),







        vatRate:







          Number.isFinite(Number(this.data.vatRate))







            ? Number(this.data.vatRate)







            : 0.20,







        estimatedPriceIncVat:







          this.calcPrice() *







          (







            1 +







            (







              Number.isFinite(Number(this.data.vatRate))







                ? Number(this.data.vatRate)







                : 0.20







            )







          )







      };







    }
    // ===== MAC fixes 26 Oct 2026 =====
    macTableTitle() {
      const p = this.product;
      const size = String(this.state.size || "").replace(/\s*x\s*/i, "\u00d7");
      const base = [p ? p.name : "", size, "welding table"].filter(Boolean).join(" ");
      // " – Ready Made, legs with castors" (same rules as snippets/mac-table-suffix.liquid)
      const b = String(this.state.build || ""), l = String(this.state.legs || ""), f = String(this.state.feet || "").toLowerCase();
      const parts = [];
      if (/self weld/i.test(b)) parts.push("Self Weld"); else if (/ready made/i.test(b)) parts.push("Ready Made");
      if (/no legs/i.test(l)) parts.push("no legs");
      else if (l) parts.push((/height adjustable/i.test(l) ? "height-adjustable legs" : "legs") + (/castor/.test(f) ? " with castors" : /feet/.test(f) ? " with feet" : ""));
      return parts.length ? base + " \u2013 " + parts.join(", ") : base;
    }
    // Preselect from URL (?table=ultra15_16d&size=3000x1500&build=ready&legs=standard&feet=castors)
    // or from window.MAC_TABLE_PRESET (used by the standard table pages).
    applyPreset() {
      let q = {};
      try { q = Object.fromEntries(new URLSearchParams(window.location.search)); } catch (e) {}
      const pre = Object.assign({}, q, window.MAC_TABLE_PRESET || {});
      if (!pre.table) return;
      const product = this.data.products.find(p => p.id === pre.table);
      if (!product) return;
      this.state.holeSystem = product.holeSystem;
      this.state.thickness = product.thickness;
      this.state.productId = product.id;
      const norm = v => String(v || "").toLowerCase().replace(/mm/g, "").replace(/[^0-9]+/g, "x");
      if (pre.size) {
        const size = (product.workingAreas || []).find(a => norm(a) === norm(pre.size));
        if (size) this.state.size = size;
      }
      const pick = (list, v) => {
        if (!list || !v) return null;
        v = String(v).toLowerCase();
        return list.find(o => o.toLowerCase() === v) || list.find(o => o.toLowerCase().indexOf(v) !== -1) || null;
      };
      const legs = pick(product.legs, pre.legs); if (legs) this.state.legs = legs;
      const feet = pick(product.feet, pre.feet); if (feet) this.state.feet = feet;
      const build = pick(product.build, pre.build); if (build) this.state.build = build;
      const colour = pick(product.legColors, pre.colour || pre.color); if (colour) this.state.legColor = colour;
      this.macPreset = true;
    }
    macAfterAdd() {
      const drawer = document.querySelector("m-cart-drawer");
      const onCartPage = window.MinimogSettings && window.MinimogSettings.templateName === "cart";
      if (!drawer || onCartPage || typeof drawer.open !== "function") {
        window.location.href = "/cart?added=1";
        return;
      }
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } }));
      // Belt and braces: open it ourselves too, then show the message once the drawer has re-rendered.
      setTimeout(() => { try { if (!drawer.classList.contains("m-cart-drawer--active")) drawer.open(); } catch (e) {} }, 400);
      this.macAddedNotice(drawer);
    }
    macAddedNotice(drawer) {
      const show = () => {
        const inner = drawer.querySelector(".m-cart-drawer__inner") || drawer;
        let n = inner.querySelector(".mac-added");
        if (!n) {
          n = document.createElement("div");
          n.className = "mac-added";
          n.setAttribute("role", "status");
          n.innerHTML = '<p class="mac-added__msg"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" fill="none" stroke="currentColor" stroke-width="2.4"/></svg> Added to your basket</p>' +
            '<a class="mac-added__btn" href="/checkout">Checkout</a>';
          const head = inner.querySelector(".m-cart-drawer__header");
          if (head) head.insertAdjacentElement("afterend", n);
          else { const body = inner.querySelector(".m-cart-drawer__body"); if (body) body.parentNode.insertBefore(n, body); else inner.appendChild(n); }
        }
      };
      show();
      setTimeout(show, 900);   // the drawer body is re-rendered after the cart refresh
      setTimeout(show, 2200);  // and again if the free gift check adds the hanger
    }








    buildCartProperties() {







      const properties =







        this.buildPayload();







      const priceExVat =







        this.calcPrice();







      const vatRate =







        Number.isFinite(Number(this.data.vatRate))







          ? Number(this.data.vatRate)







          : 0.20;







      const priceIncVat =







        priceExVat * (1 + vatRate);







      const prefixedProperties =







        {};







      Object.keys(properties).forEach(key => {







        const value =







          properties[key];







        if (







          value === null ||







          value === undefined ||







          value === ""







        ) {







          return;







        }







        prefixedProperties[







          `_${key}`







        ] = String(value);







      });







      /* MAC fix 26 Oct 2026 (b): customer-facing keys first (no underscore, shown at checkout); all others stay underscore-prefixed (hidden by Shopify). _all_props keeps every key except null/empty values. */
      const visible = {};
      const vis = (k, v) => { if (v !== null && v !== undefined && String(v).trim() !== "") visible[k] = String(v); };
      vis("Table", this.macTableTitle());
      vis("Size", properties.size);
      vis("Build", properties.build);
      vis("Legs", [properties.legs, properties.feet].filter(Boolean).join(", "));
      vis("Finish", properties.legColor);
      vis("Comments", properties.comments);
      if (properties.build === "Self Weld Kit") vis("Assembly Plates", this.platesLabel());
      const cleanAll = {};
      /* MAC fix 26 Oct 2026 (c): a Cart Transform (BUNDLES_DYNAMIC_EXPAND, keyed on __price) copies every key of _all_props onto the
         expanded checkout/order line as its properties. So: customer keys as-is, every internal key underscore-prefixed (hidden). */
      Object.assign(cleanAll, visible);
      Object.keys(properties).forEach(k => { const v = properties[k]; if (v !== null && v !== undefined && v !== "") cleanAll["_" + k] = v; });
      return { ...visible, __price: priceIncVat.toFixed(2), ...prefixedProperties, _all_props: JSON.stringify(cleanAll) };







    }







    setBusy(button, busy) {







      if (!button) return;
      /* MAC fix (b): swap the visible label so customers see "Adding…" (min 700 ms) */
      if (busy) {
        if (button.dataset.macHtml === undefined) button.dataset.macHtml = button.innerHTML;
        button.innerHTML = '<span class="mac-busy">Adding\u2026</span>';
        button._macBusyAt = Date.now();
      } else if (button.dataset.macHtml !== undefined) {
        const restore = () => { if (button.getAttribute("aria-busy") === "true") return; button.innerHTML = button.dataset.macHtml; delete button.dataset.macHtml; };
        const wait = Math.max(0, 700 - (Date.now() - (button._macBusyAt || 0)));
        setTimeout(restore, wait);
      }







      if (busy) {







        button.dataset.label =







          button.dataset.label ||







          button.textContent.trim();







        button.disabled = true;







        button.classList.add(







          "is-busy"







        );
        button.setAttribute("aria-busy", "true");







      } else {







        button.disabled =







          !this.isConfigReady();







        button.classList.remove(







          "is-busy"







        );
        button.removeAttribute("aria-busy");







      }







    }







    isConfigReady() {







      const product =







        this.product;







      return !!(







        product &&







        this.state.size &&







        (







          !product.legs ||







          this.state.legs







        ) &&







        (







          !(product.legs && product.feet) ||







          !this.hasLegsSelected() ||







          this.state.feet







        ) &&







        (







          !product.build ||







          this.state.build







        ) &&







        (







          !(







            product.legColors &&







            this.state.build === "Ready Made by Mac"







          ) ||







          this.state.legColor







        ) &&







        this.generateSku()







      );







    }







    // =========================================================







    // PRODUCT DRAWING PDF







    // =========================================================







    downloadPdf() {







      const product =







        this.product;







      if (







        !product ||







        !product.drawingPdf







      ) {







        alert(







          "Sorry, a technical drawing is not currently available for this table."







        );







        return;







      }







      const link =







        document.createElement("a");







      link.href =







        product.drawingPdf;







      link.target =







        "_blank";







      link.rel =







        "noopener noreferrer";







      document.body.appendChild(







        link







      );







      link.click();







      document.body.removeChild(







        link







      );







    }







    // =========================================================







    // ADD TO CART







    // =========================================================







    addToQuote() {







      const product =







        this.product;







      if (







        !product ||







        !this.isConfigReady()







      ) {







        return;







      }







      const variantId =







        this.getShopifyVariantId(







          product,







          this.state.size







        );







      if (!variantId) {







        alert(







          "This table size has not yet been linked to a Shopify variant. Please add its variant ID in the configurator DATA file."







        );







        return;







      }







const items = [

  {

    id: variantId,

    quantity: 1,

    properties: this.buildCartProperties()

  },



  // FREE CLAMP HANGER — EVERY WELDING TABLE

  {

    id: 39625370468557,

    quantity: 1,

    properties: {

      "_MAC Free Gift": "Clamp Hanger 400mm",

      "_Gift For": this.generateSku()

    }

  }

];



/* MAC fix 26 Oct 2026: the free clamping plates are no longer added as a separate line (variant 37418647912653 is £22.99 in Shopify).
   They are recorded on the table line instead, so the workshop still sees them and nothing is charged. */
items[0].properties = Object.assign({ "Table": this.macTableTitle() }, items[0].properties);
if (this.state.build === "Self Weld Kit") {
  items[0].properties["Assembly Plates"] = this.platesLabel();
}



/* §101 OPTIONAL ASSEMBLY STUD KIT — only when ticked (self weld, sizes with a plate count). Paid line at the normal Shopify price. */
const studKit = this.getStudKitSelected();
if (studKit) {
  items.push({
    id: studKit.variant.id,
    quantity: studKit.qty,
    properties: Object.assign({
      "_Stud Kit For": this.generateSku()
    }, studKit.single ? { "_Stud unit": "single" } : {})
  });
}
const payload = {

  items: items

};



      this.setBusy(







        this.els.addToQuote,







        true







      );







      fetch(







        "/cart/add.js",







        {







          method:







            "POST",







          headers: {







            "Content-Type":







              "application/json"







          },







          body:







            JSON.stringify(payload)







        }







      )







        .then(res => {







          if (!res.ok) {







            return res







              .json()







              .then(err =>







                Promise.reject(err)







              );







          }







          return res.json();







        })







        .then(() => {
          this.macAfterAdd();







          this.root.dispatchEvent(







            new CustomEvent(







              "welding-configurator:add-to-quote",







              {







                detail:







                  this.buildPayload(),







                bubbles:







                  true







              }







            )







          );







        })







        .catch(err => {







          console.error(







            "Welding configurator: add to cart failed:",







            err







          );







          alert(







            (







              err &&







              (







                err.description ||







                err.message







              )







            )







            ||







            "Sorry, something went wrong adding this to your cart."







          );







        })







        .finally(() =>







          this.setBusy(







            this.els.addToQuote,







            false







          )







        );







    }







    requestQuote() {







      const payload =







        this.buildPayload();







      this.root.dispatchEvent(







        new CustomEvent(







          "welding-configurator:request-quote",







          {







            detail:







              payload,







            bubbles:







              true







          }







        )







      );







      console.log(







        "Request quote:",







        payload







      );







    }







  }







  // =========================================================







  // START CONFIGURATOR







  // =========================================================







  document.addEventListener(







    "DOMContentLoaded",







    function () {







      document







        .querySelectorAll(







          "[data-welding-configurator]"







        )







        .forEach(root => {







          if (







            window.WELDING_CONFIGURATOR_DATA







          ) {







            new WeldingConfigurator(







              root,







              window.WELDING_CONFIGURATOR_DATA







            );







          }







        });







    }







  );







})();